module.exports = __webpack_public_path__ + "img/revolvingQuota.9b395271.png";